define('SuiteDynamics.DescriptionImage.SS2Model', [
    'SCModel',
    'Utils'
],
function (
    SCModelModule,
    Utils
) {
    'use strict';

    var SCModel = SCModelModule.SCModel;

    function DescriptionImageModel () {
        SCModel.call(this);

        this.urlRoot = function urlRoot() {
            return Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    'Modules/DescriptionImage/SuiteScript2/SuiteDynamics.DescriptionImage.Service.ss'
                ),
                true
            );
        };
    }

    DescriptionImageModel.prototype = Object.create(SCModel.prototype);
    DescriptionImageModel.prototype.constructor = DescriptionImageModel;

    return DescriptionImageModel;
});
